import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { notify } from 'helpers/notification'
import {
    sendSignUpOtp as sendOtpRequest,
    verifySignUpOtp as verifyOtpRequest,
} from 'services/apis/otp'
import { performLogin, removeUserCookies } from 'store/thunks/User'

import { handleError } from '../../helpers/error'
/**
 * This hook is used to perform actions based on
 * the OTP and phone number input by the user.
 *
 * This hook exposes abiltity to change the userModel states
 * Do not alter the userModel state for OTP using any other way
 */

const useSignupOtp = () => {
    // local hooks
    const [otpSending, setOtpSending] = useState(false)
    const [otpVerifying, setOtpVerifying] = useState(false)
    const dispatch = useDispatch()

    /**
     * Takes in the phone number of the user and sends OTP
     * to the mobile phone of the user
     *
     * @param name
     * @param phone_number
     * @param parent_phone_number
     */
    const sendOtp = async (name, phone_number, parent_phone_number) => {
        try {
            removeUserCookies()
            setOtpSending(true)
            const { firstName: first_name, lastName: last_name } = name
            await sendOtpRequest({
                first_name,
                last_name,
                phone_number,
                parent_phone_number,
            })
            notify.success(`OTP Sent to ${phone_number}`)
            return true
        } catch (error) {
            console.log('error :- ', error)
            handleError(error)
            return false
        } finally {
            setOtpSending(false)
        }
    }

    /**
     * Takes in the same phone number and the received OTP to
     * return an access token in form of a JWT
     * This JWT is then used as a auth header for all other
     * protected routes
     *
     * @param phone_number
     * @param otp
     */
    const verifyOtp = async (phone_number, otp) => {
        if (!phone_number || !otp) {
            return
        }

        try {
            setOtpVerifying(true)
            const { data } = await verifyOtpRequest({
                phone_number: phone_number,
                verification_code: otp,
            })
            setOtpVerifying(false)
            dispatch(performLogin(data))
        } catch (error) {
            setOtpVerifying(false)
            handleError(error)
        }
    }

    return { sendOtp, otpSending, verifyOtp, otpVerifying }
}

export default useSignupOtp
